module.exports = __webpack_public_path__ + "prod/1.42.2/img/wechat.7c8c233b.svg";